import cx from 'classnames'
import React, { ReactNode } from 'react'

import Styles from './Button.module.scss'
import { useFocusRing } from '@react-aria/focus'
import { mergeProps } from '@react-aria/utils'

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
  active?: boolean
  selected?: boolean
  disabled?: boolean
  unStyled?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    children,
    className = '',
    // The function this button applies is currently active in the selection
    active = false,
    // You tab or arrow clicked your way to this button
    selected = false,
    disabled = false,
    unStyled = false,
    ...props
  },
  forwardRef,
) {
  const { isFocusVisible, focusProps } = useFocusRing()
  return (
    <button
      ref={forwardRef}
      className={cx(
        Styles.button,
        {
          [Styles.styledButton]: !unStyled,
          [Styles.buttonActive]: active,
          [Styles.buttonSelected]: selected,
          [Styles.buttonDisabled]: disabled,
          [Styles.focused]: isFocusVisible,
        },
        className,
      )}
      disabled={disabled}
      {...mergeProps(focusProps, props)}
    >
      {children}
    </button>
  )
})

export const SoftButton = React.forwardRef<HTMLButtonElement, ButtonProps>(function SoftButton(
  { children, className = '', ...props },
  forwardRef,
) {
  return (
    <Button ref={forwardRef} unStyled className={cx(Styles.softButton, className)} {...props}>
      {children}
    </Button>
  )
})
